

export const ShowLoader = (loader: JQuery) => {

    $('.pageWrap').addClass("overlayCover");
    loader.show();
    
    if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
        window.scrollTo(0,0);
    }else{
        $('html,body').animate({
            scrollTop: 0
        }, 600, function(){
            $('html,body').clearQueue();
        });
    }
}